import { jsx as _jsx } from "react/jsx-runtime";

function SvgSend() {
  return _jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22.707 1.293a1 1 0 01.25.994l-6 20a1 1 0 01-1.86.141l-4.348-9.177-9.177-4.347a1 1 0 01.14-1.862l20-6a1 1 0 01.995.25zM12.705 12.709l3.085 6.511 4.113-13.708-7.198 7.197zm5.783-8.611L4.78 8.21l6.511 3.085 7.197-7.197z"
    }, void 0)
  }), void 0);
}

export default SvgSend;